import { FeedbotThunk } from '../../../store/types'
import { checkRole } from '@feedyou/utils'
import { botsApi } from '@features/serverBots/api/botsApi'
import { feedbotToast } from '../../../lib/feedbotToast'
import { switchBot } from '../../../lib/navigation'
import { BotId } from '@feedyou/schema'

export const switchToBotIfCurrentUserCanViewIt =
  (botId: BotId): FeedbotThunk =>
  async (dispatch, getState) => {
    const permissions = await dispatch(
      botsApi.endpoints.getCurrentUserPermissionsForBot.initiate({ botId })
    ).unwrap()

    if (!checkRole({ role: permissions.role, minRequiredRole: 'view' })) {
      toastNotifyInsufficientPermissions(botId)
      return
    }

    switchBot(botId)
  }

function toastNotifyInsufficientPermissions(botId: string) {
  feedbotToast.error({
    title: `Cannot switch to bot ${botId}`,
    id: 'toastNotifyInsufficientPermissions',
    content: "You don't have permissions to view this bot"
  })
}
